<template>
    <div id="sources" class="root">
        <div class="row">
            <div class="col-lg-12 content-title mt-1 mb-3">
                <h2 class="content-title">Google hirdetések</h2>
            </div>
        </div>
        <loader :loading="loading_status"></loader>
        <div class="row">
            <div class="col-lg-12 content-body" v-if="!loading_status">
                <div class="google_ads-list">
                    <div class="row">
                        <div class="col-lg-12 text-right text-primary pr-lg-4 mb-2">
                            {{ google_ads_list ? google_ads_list.length : 0 }} találat
                        </div>
                    </div>
                    <div class="row form-group component-list">
                        <div class="col-sm-12">
                            <table class="table table-striped mt-3">
                                <thead class="thead-dark">
                                <tr>
                                    <th scope="col" width="5%" class="text-left">#</th>
                                    <th scope="col" width="20%" class="text-left">Név</th>
                                    <th scope="col" width="10%" class="text-center">Méret</th>
                                    <th scope="col" width="15%" class="text-center">Létrehozta</th>
                                    <th scope="col" width="15%" class="text-center">Módosítva</th>
                                    <th scope="col" width="20%" class="text-center">Pozició</th>
                                    <th scope="col" width="15%" class="text-center">

                                    </th>
                                </tr>
                                </thead>
                                <tbody v-if="!loading_status">
                                <tr v-for="item in google_ads_list" v-bind:data="item" v-bind:key="item.id">
                                    <th class="text-primary text-left">#{{ item.id }}</th>
                                    <td class="text-left">{{ item.name }}</td>
                                    <td class="text-center">{{ item.width }}x{{ item.height }}</td>
                                    <td class="text-center">{{ item.full_name }}</td>
                                    <td class="text-center">{{ item.last_update | formatDate }}</td>
                                    <td class="text-center">{{ item.position }}</td>
                                    <td class="text-center">
                                        <a v-on:click.prevent="editGoogleAd(item)" v-if="isDeveloper"><i class="far fa-edit text-success mr-2 c-pointer" title="Szerkesztés"></i></a>
                                        <a v-on:click.prevent="confirmDelete(item)" v-if="isDeveloper"><i class="fas fa-trash-alt text-danger mr-3 c-pointer" title="Törlés"></i></a>

                                        <a v-on:click.prevent="" v-show="item.position == ''"><i class="far fa-check-circle mr-3 text-secondary c-pointer" title="Inaktív"></i></a>
                                        <a v-on:click.prevent="" v-show="item.position != ''">
                                            <i class="far fa-check-circle text-success mr-3 c-pointer" title="Aktív"></i>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row scontrols">
                        <div class="col-lg-6 justify-content-center">
                            <div class="row form-group">
                                <div class="col-sm-5 mt-lg-4 col-lg-6 pt-sm-4 pt-lg-0" v-if="isDeveloper">
                                    <button class="btn btn-md btn-primary" @click="editGoogleAd({})">Új Google hirdetés</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <GoogleAdDialog :show="showModal" @close="showModal = false" :data="modalData" @onProcessed="onGoogleAdSaved"></GoogleAdDialog>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { mapGetters, mapActions } from 'vuex'
    import axios from 'axios'
    import Loader from '../common/controls/Loader'
    import GoogleAdDialog from "./dialogs/GoogleAdDialog";

    export default{
        name: 'google-ads',
        data(){
            return{
                google_ads: {},
                showModal: false,
                modalData: { title: '', side: ''},
            }
        },
        components: {
            Datepicker,
            Loader,
            GoogleAdDialog
        },
        computed: {
            ...mapGetters([
                'googleAdsList',
                'user',
                'loading',
                'userID',
            ]),
            loading_status: {
                get: function() {
                    return this.loading ? this.loading : false;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            google_ads_list: {
                get:function() {
                    return this.googleAdsList;
                },
                set:function(newVal) {
                    return newVal;
                }
            },
        },
        methods: {
            ...mapActions([
                'getGoogleAds',
                'addGoogleAd',
                'updateGoogleAd',
                'deleteGoogleAd',
            ]),
            editGoogleAd(item) {
                if(item.name) {
                    this.google_ads = item;
                    this.modalData = item;
                    this.modalData.method = this.getByID;
                    console.log('loading modal', this.modalData);
                } else {
                    this.google_ads = { name: '', position: '', }
                    this.modalData = this.google_ads;
                }

                this.showModal = true;
            },
            confirmDelete(item) {
                let vm = this;
                this.$dialog.confirm('Tényleg szeretné törölni a #'+item.title+' hirdetést?', {})
                    .then((dialog) => {
                        vm.deleteGoogleAd({
                            id: item.id,
                        }).then((response) => {
                            dialog.close();
                        });
                    });
            },
            newItem() {
                this.google_ads = {};
            },
            getByID(id) {
                axios.get('/api/ga/'+id)
                    .then((response) => {
                        this.modalData = response.data;
                    }).catch((e) => {
                    console.log('unable to get google_ads', e);
                })
            },
            onGoogleAdSaved(data) {
                if(data) {
                    data.user_id = this.userID;

                    if (data.id) {
                        this.updateGoogleAd(data);
                    } else {
                        this.addGoogleAd(data);
                    }
                } else {
                    this.$store.commit('Hiba a mentés közben');
                }
            },
            isDeveloper() {
                return this.user.is_developer;
            }
        },
        mounted() {
            this.getGoogleAds();
        },
        watch: {
            googleAdsList: function(newVal) {
                this.google_ads_list = newVal;
            },

        },
    }
</script>

<style scoped="" lang="scss">
    button{
        padding-bottom: 7px;
    }
    .action-buttons input[type=checkbox]{
        position: relative;
        top: 1px;
        right: 3px;
    }
    .scontrols {
        button {
            margin-top: 5px;
            height: 33px;
        }
    }

    td {
        i {
            padding-right: 3px;
            cursor: pointer;
        }
    }
</style>